import React from 'react';
import { formatToGroupedThousands } from '../../utils/number';

if (process.browser) require('./SearchResultStats.scss');

const ItemsCount = ({ fromItem, toItem }) => (
  <span className="count">
    <span data-name="first-item-position">{ formatToGroupedThousands(fromItem) }</span>
    {' - '}
    <span data-name="last-item-position">{ formatToGroupedThousands(toItem) }</span>
  </span>
);

const TotalCount = ({ total }) => (
  <span className="count" data-name="total-count">
    { formatToGroupedThousands(total) }
  </span>
);

export default function SearchResultStats({
  currentPage,
  itemsPerPage,
  itemsCount,
  total,
}) {
  const firstItemPosition = ((currentPage - 1) * itemsPerPage) + 1;
  const lastItemPosition = (firstItemPosition - 1) + (itemsCount || itemsPerPage);

  return (
    <p className="search-result-stats" data-name="search-result-stats">
      {'Results '}
      <ItemsCount fromItem={firstItemPosition} toItem={lastItemPosition} />
      {' of '}
      <TotalCount total={total} />
    </p>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/SearchResultStats/SearchResultStats.js